import { useMutation } from "@tanstack/react-query";
import { authService } from "../authService";

/**
 * Valida o código de recuperação na hora (passo opcional), antes de avançar
 * para a tela de nova senha. `phone` vem fixo da query da etapa anterior.
 */
export const useSendSecurityCode = ({ phone }: { phone: string }) => {
  const { mutate, isPending } = useMutation<void, Error, string>({
    mutationFn: code => authService.handleSendSecurityCode({ phone, code }),
  });

  return {
    sendSecurityCode: mutate,
    isSendingSecurityCode: isPending,
  };
};
